import { UNAVAILABLE_DASH } from "util/formatter"

import { TableDataType } from "./eums"
import { TableColumnsInterface } from "./interfaces"

export const tableKYCFilesColumns: TableColumnsInterface[] = [
  {
    value: "id",
    title: "Id",
    format: TableDataType.SHORTENED_STRING,
    sorting: true
  },
  {
    value: "user.username",
    title: "User",
    format: TableDataType.STRING,
    sorting: false
  },
  {
    value: "user.totalWalletBalance",
    title: "Balance",
    format: TableDataType.STRING,
    sorting: false,
    mntSorting: true,
    // SOFT-570: compliance officers factor this into approve/reject. In microservice mode the
    // fail-closed backend sends `totalWalletBalance: null` + `user.balance_unavailable` when the
    // balance authority is down — render a dash, never a stale/`$0` number.
    customRender: (value, row) => (row?.user?.balance_unavailable ? UNAVAILABLE_DASH : value)
  },
  {
    value: "img_idcard_front",
    title: "IDCard Front",
    format: TableDataType.FILE,
    customRender: (value: string) => (value ? "✔️" : "❌"),
    sorting: true
  },
  {
    value: "img_idcard_back",
    title: "IDCard Back",
    format: TableDataType.FILE,
    customRender: (value: string) => (value ? "✔️" : "❌"),
    sorting: true
  },
  {
    value: "doc_proof_address",
    title: "Proof of Address",
    format: TableDataType.FILE,
    customRender: (value: string) => (value ? "✔️" : "❌"),
    sorting: true
  },
  {
    value: "doc_add_verify",
    title: "Verification Document",
    format: TableDataType.FILE,
    customRender: (value: string) => (value ? "✔️" : "❌"),
    sorting: true
  },
  {
    value: "status",
    title: "Status",
    format: TableDataType.STRING,
    sorting: true
  },
  {
    value: "created_at",
    title: "Created At",
    format: TableDataType.DATE,
    sorting: true
  },
  {
    value: "updated_at",
    title: "Updated At",
    format: TableDataType.DATE,
    sorting: true
  }
]
